// extracted by mini-css-extract-plugin
module.exports = {"Table":"style_Table__2hXHu","Item":"style_Item__2eBek","TableHeading":"style_TableHeading__SR8Ai","TableImage":"style_TableImage__1CfXK"};